import { render, staticRenderFns } from "./insightsList.vue?vue&type=template&id=a7a58792&scoped=true&"
import script from "./insightsList.vue?vue&type=script&lang=js&"
export * from "./insightsList.vue?vue&type=script&lang=js&"
import style0 from "./insightsList.vue?vue&type=style&index=0&id=a7a58792&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7a58792",
  null
  
)

export default component.exports